// RefundPolicy.jsx
import React from "react";
import { RefreshCw } from "lucide-react";
import "./LegalPages.css";
import Footer from "./footer";

const RefundPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <div className="legal-header">
          <div className="header-title">
            <RefreshCw className="header-icon blue" />
            <h1>Cancellation & Refund Policy</h1>
          </div>
          <p className="breadcrumb">Home / Cancellation & Refund Policy</p>
        </div>

        <section className="legal-section">
          <div><h2>1. Cancellation Policy</h2><ul><li>Once a purchase order for unlisted or pre-IPO shares is confirmed, cancellation requests will generally not be accepted.</li><li>Users are strongly advised to verify all transaction details carefully before confirming any purchase.</li></ul></div>

          <div><h2>2. Refund Policy</h2><ul><li>Refunds will only be considered when regulatory or compliance approvals required to complete the transaction are not granted.</li><li>Refunds will be processed to the original payment account within a reasonable timeframe.</li></ul></div>

          <div><h2>3. Non-Refundable Scenarios</h2><ul><li>Purchase confirmations that have passed the regulatory verification stages are non-refundable.</li><li>No refunds for market fluctuations or change of mind.</li></ul></div>
        </section>
      </div>
          <Footer />
    </div>
  );
};

export default RefundPolicy;